<script setup>
import { ref, reactive } from 'vue';
import TabNavigator from '@/Shared/Navigation/TabNavigator';
import RainbooIcon from '@/Shared/SVG/RainbooIcon';
import ContactPanner from '@/Shared/ContactPanner';
import ReasonCards from '@/Shared/ReasonCards';

let props = defineProps({
    data: Object,
});

let tabNavigation = [
    { name: 'Game Hub', href: route('gaming.gameHub'), current: false },
    { name: 'Game Store', href: route('gaming.gameStore'), current: false },
    { name: 'XWGT', href: route('gaming.xwgt'), current: false },
    { name: 'Marketplace', href: route('gaming.marketplace'), current: true },
    { name: 'Incubation', href: route('gaming.incubation'), current: false },
    { name: 'Hosting', href: route('gaming.hosting'), current: false },
    { name: 'Development', href: route('gaming.development'), current: false },
];
</script>

<template>
    <div class="relative w-full">
        <TabNavigator :tabs="tabNavigation" />
        <h1
            class="m-auto mt-12 max-w-lg px-2 text-center text-3xl font-bold font-bold text-white sm:mt-16"
        >
            {{ data.title }}
        </h1>
        <div class="relative mt-28 mb-40 sm:mt-20">
            <div
                class="flex grid-cols-1 flex-col items-center justify-items-end gap-16 sm:grid lg:grid-cols-12"
            >
                <div class="col-span-6">
                    <div>
                        <p class="mb-6 text-[26px] text-white text-opacity-60">
                            {{ data.section_1.title }}
                        </p>
                    </div>
                    <div>
                        <p class="text-white text-opacity-60">
                            {{ data.section_1.content }}
                        </p>
                    </div>
                </div>
                <div class="col-span-6">
                    <img
                        class="max-h-[440px] w-full max-w-[798px] rounded-2xl object-right"
                        :src="data.section_1.image"
                        :alt="data.section_1.title"
                    />
                </div>
            </div>
            <!--            -->
            <div
                class="mt-12 flex grid-cols-1 flex-col items-center justify-items-start gap-16 sm:grid lg:grid-cols-12"
            >
                <div class="order-last col-span-6 lg:order-first">
                    <img
                        class="max-h-[440px] w-full max-w-[798px] rounded-2xl"
                        :src="data.section_2.image"
                        :alt="data.section_2.title"
                    />
                </div>
                <div class="col-span-6">
                    <div>
                        <p class="mb-6 text-[26px] text-white text-opacity-60">
                            {{ data.section_2.title }}
                        </p>
                    </div>
                    <div>
                        <p class="text-white text-opacity-60">
                            {{ data.section_2.content }}
                        </p>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-20 w-full border-b border-wgn-purple-4">
                <RainbooIcon class="m-auto" />
            </div>
            <div class="mt-3">
                <h2 class="mb-7 text-center text-[22px] text-white">
                    {{ data.section_3.title }}
                </h2>
                <ReasonCards :cards="data.section_3.cards"></ReasonCards>
            </div>

            <div class="mt-20">
                <ContactPanner></ContactPanner>
            </div>
        </div>
    </div>
</template>
